import { useEffect, useState } from 'react'
import { get, forEach, keys } from 'lodash'
import { off, onValue, ref, serverTimestamp, set } from 'firebase/database'

import { auth, db } from '../firebase'

const convertToRanks = (voteArray, omits = {}) => {
  const saveRanks = {}
  forEach(voteArray, (vote, i) => {
    saveRanks[vote.id] = { idx: i }
  })
  forEach(keys(omits), omitKey => {
    saveRanks[omitKey] = { idx: -1 } // omit candidates get an index of -1 ?
  })
  return saveRanks
}

const usePostUserVote = ({ isQuick = false, postId }) => {
  const uid = get(auth, 'currentUser.uid')
  const refPath = isQuick ? `quickVotes/${postId}/${uid}` : `votes/${postId}/${uid}`

  const [vote, setVote] = useState()
  const [loading, setLoading] = useState(true)

  let postVoteRef

  useEffect(() => {
    const get = () => {
      setVote() // in case the postId changes, the vote must be nullified
      postVoteRef = ref(db, refPath)
      onValue(postVoteRef, (item) => {
        if (item.val()) {
          setVote({
            ...item.val(),
            id: postId
          })
        }
        setLoading(false)
      })
    }
    get()

    return () => {
      if (postVoteRef) { // close the connection
        off(postVoteRef)
      }
    }
  }, [postId])

  const saveVote = (userVote, isAbstain = false) => {
    const myVoteRef = ref(db, refPath)

    const voteData = {
      ranks: convertToRanks(userVote),
      createdAt: serverTimestamp(),
      abstained: false
    }

    return set(myVoteRef, voteData)
  }

  const abstain = (userVote) => {
    return saveVote(userVote, true)
  }

  return {
    vote,
    loading,
    saveVote,
    abstain
  }
}

export default usePostUserVote
